import React from 'react';
import { Quaternion, Vector3 } from 'three';

import { newVector3, Segment3D } from '@paragon/three-shared';

import { LabelVisual } from './LabelVisual';

interface Props {
  readonly segment: Segment3D;
  readonly text: string;
  readonly position?: readonly [number, number, number];
  readonly quaternion?: Quaternion;
}

export function SegmentLabel({ segment, text, position, quaternion }: Props) {
  const { start, end } = segment;
  const vector = newVector3(end).sub(newVector3(start));
  const offset = newVector3(vector)
    .normalize()
    .applyAxisAngle(new Vector3(0, 0, 1), Math.PI / 2);
  const center = newVector3(vector).multiplyScalar(0.5).add(offset);
  const direction = newVector3(vector).normalize();
  const labelPosition = newVector3(start).add(center);
  let rotation = new Vector3(1, 0, 0).angleTo(direction);
  // use smallest angle
  if (vector.y < 0) {
    rotation = -rotation;
  }
  // flip text over for readability
  if (vector.x < 0) {
    rotation += Math.PI;
  }

  return (
    <object3D position={position} quaternion={quaternion}>
      <LabelVisual fontSize={1} position={[labelPosition.x, labelPosition.y, labelPosition.z]} rotation={rotation}>
        {text}
      </LabelVisual>
    </object3D>
  );
}
